module.exports = __webpack_public_path__ + "static/mr-concert-performance-18-814877d12fd05fb28aa866021603813c.jpg";